import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const ArrowRightSmallIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8216 11.4667L16.0668 7.71666C15.7724 7.42257 15.295 7.42257 15.0005 7.71666C14.7061 8.01075 14.7061 8.48757 15.0005 8.78166L17.4786 11.2492L5.77145 11.2492C5.35672 11.2492 5.02051 11.5849 5.02051 11.9992C5.02051 12.4134 5.35672 12.7492 5.77145 12.7492L17.4786 12.7492L15.0005 15.2167C14.8583 15.3575 14.7784 15.5492 14.7784 15.7492C14.7784 15.9491 14.8583 16.1408 15.0005 16.2817C15.1415 16.4236 15.3335 16.5035 15.5337 16.5035C15.7339 16.5035 15.9258 16.4236 16.0668 16.2817L19.8216 12.5317C19.9637 12.3908 20.0437 12.1991 20.0437 11.9992C20.0437 11.7992 19.9637 11.6075 19.8216 11.4667Z",
    fill: color,
    fillOpacity: "0.945098"
  }));
};
export default ArrowRightSmallIcon;